import Datepicker from "@vuepic/vue-datepicker"

import '@vuepic/vue-datepicker/dist/main.css'

export default Datepicker
